import styled from 'styled-components'
import Link from 'next/link'

export const TileContent = styled.div`
  @media (max-width: 767px) {
    flex-grow: 1;
  }
`

export const ProductImage = styled.div`
  position: relative;
  background-position: center center;
  background-size: cover;
  border-radius: 12px;
  width: 100%;
  height: 224px;
  margin-bottom: 12px;
  transition: 0.1s ease-in-out;
  overflow: hidden;

  img {
    width: 100%;
    height: 100%;
    transition: 0.25s var(--cubicBezierImage);
    object-fit: cover;
  }

  @media (max-width: 900px) {
    width: 100%;
    height: 200px;
  }
`

export const HotDealTooltip = styled.div`
  position: absolute;
  bottom: 32px;
  left: 0;
  margin: 0 4px;
  line-height: 1.2;
  font-size: 13px;
  color: white;
  background: var(--sale);
  padding: 6px;
  border-radius: 4px;
  font-weight: var(--font-medium);
  opacity: 0;
`

export const Badges = styled.div`
  position: absolute;
  background: white;
  padding: 7px 6px 0 0;
  border-radius: 0 8px 0 0;
  left: 0;
  top: 198px;
  display: flex;
  transition: 0.1s ease-in-out;
  z-index: 1;

  svg {
    flex-shrink: 0;
  }

  > div {
    white-space: nowrap;
  }

  & > div:not(:last-child) {
    margin-right: 8px;
  }

  @media (max-width: 767px) {
    top: 170px;
    padding: 0;
    background: transparent;
  }
`

export const Badge = styled.div<{ variant: string }>`
  border-radius: 4px;
  background: ${({ variant }) => {
    switch (variant) {
      case 'BEST_SELLER':
        return 'var(--brand-primary)'
      case 'MEALS_INCLUDED':
        return 'var(--ui-green)'
      case 'HOT_DEAL':
        return 'var(--sale)'
      default:
        return 'var(--brand-secondary)'
    }
  }};
  color: ${({ variant }) => {
    switch (variant) {
      case 'BEST_SELLER':
        return 'var(--brand-secondary)'
      case 'MEALS_INCLUDED':
        return 'white'
      case 'HOT_DEAL':
        return 'white'
      default:
        return 'white'
    }
  }};
  padding: 4px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: var(--font-medium);
  display: flex;
  align-items: center;
  gap: 6px;

  & > svg {
    margin-top: -2px;
    width: 12px;
    height: 12px;
  }
  @media (max-width: 767px) {
    font-size: 11px;

    ${({ variant }) =>
      variant === 'HOT_DEAL' &&
      `
      display: none;
    `}

    svg {
      width: 9px;
      height: 9px;
    }
  }
`

export const Header = styled.div`
  display: flex;
  align-items: center;
  font-size: 12px;
  color: #868686;
  margin-bottom: 6px;
`

export const Main = styled.div`
  margin-bottom: 10px;
`

export const Rating = styled.div`
  font-size: 12px;
  font-weight: var(--font-medium);
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-bottom: 8px;

  span {
    margin-left: 4px;
  }
`

export const Title = styled.h3`
  font-size: 16px;
  line-height: 21px;
  font-weight: var(--font-medium);
  display: -webkit-box;
  width: 100%;
  -webkit-box-orient: vertical;
  overflow: hidden;

  @media (min-width: 769px) {
    min-height: 42px;
    margin-bottom: 8px;
    -webkit-line-clamp: 2;
  }
  @media (max-width: 767px) {
    font-size: 14px;
    line-height: 1.3;
  }
`

export const Supplier = styled.span`
  display: block;
  font-size: 14px;
  color: #868686;
  font-weight: var(--font-medium);

  @media (min-width: 769px) {
    overflow: hidden;
    display: -webkit-box;
    width: 100%;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
  }

  @media (max-width: 768px) {
    display: none;
  }
`

export const Pricing = styled.div<{ bookingEngineTile?: boolean; onSale: boolean }>`
  margin-top: auto;
  font-size: 12px;
  font-weight: var(--font-regular);

  s {
    text-decoration: line-through;
  }
  span {
    font-size: 14px;
    font-weight: var(--font-medium);
    ${({ onSale }) =>
      onSale &&
      `
      color: var(--sale);
  `}
  }

  ${({ bookingEngineTile }) =>
    bookingEngineTile &&
    `
    margin-top: 10px;
    font-size: 15px;
    
    span {
      font-size: 17px;
    }
  `}
`

export const PointsBadgeContainer = styled.div`
  margin-top: 8px;
`

export const ProductTileWrap = styled.div<{ mobileTile: boolean }>`
  ${({ mobileTile }) =>
    mobileTile &&
    `
      @media (max-width: 767px) {
        border-bottom: 1px solid var(--grey-25);
        padding: 20px 0;
        
        &:first-child {
          padding-top: 0;
        }
        &:last-child {
          border-bottom: 0;
          padding-bottom: 0;
        }
      }
    `}
`
export const LinkWrapper = styled(Link)`
  text-decoration: none;
`
export const Wrapper = styled.div<{ mobileTile: boolean }>`
  text-decoration: none;
  color: ${({ theme }) => theme.text?.colours.body};
  display: flex;
  flex-direction: column;
  height: 100%;
  position: relative;

  &:hover {
    ${HotDealTooltip} {
      opacity: 1;
    }
    > div:first-child img {
      transform: scale(1.1);
    }
  }

  ${({ mobileTile }) =>
    mobileTile &&
    `
      @media (max-width: 767px) {
        flex-direction: row;
        align-items: flex-start;
        gap: 15px;
        flex-wrap: wrap;
        height: unset;

        ${ProductImage} {
          width: 140px;
          height: 110px;
          margin: 0;
          border-radius: 8px;
        }
        ${TileContent} {
          width: calc(100% - 160px);
        }
        ${Badges} {
          position: static;
          margin: 10px 0;
        }
      }
  `}
`

export const LargeTitle = styled.h3`
  font-size: 20px;
  line-height: 1.2;
  display: block;
  margin-bottom: 8px;
  font-weight: var(--font-medium);
  width: 100%;
`

export const Summary = styled.p`
  font-size: 16px;
  margin-top: 15px;
  font-weight: var(--font-regular);
  line-height: 1.5;
`
